import React, { Component } from 'react'
import AddNew from './actions/AddNew'
import SkuTable from "./SkuTable"
import NextPagination from "../../components/Pagination/NextPagination"
import { Card, CardBody } from "reactstrap"
import SkuFilters from "./SkuFilters"
import SkuTotal from "./SkuTotal"
import { getListSku } from "../../services/api/apiSku"
import Import from "./actions/Import";
import { getLocalData } from "../../services/StorageServices";
import { parseJwt } from "../../share/parseToken";
import { getListPartner } from '../../services/api/3dApi'
import { getListMaterials, getListProductionMethods, getProductionProcess, getListCatalog } from '../../services/api/apiSku'
import { Link } from 'react-router-dom'
class SkuPage extends Component {
    constructor(props) {
        super(props)

        this.timeout = 0

        this.state = {
            loading: false,
            error: '',
            message: '',
            filters: {
                name: '',
                sku: []
            },
            products: [],
            page: 1,
            limit: 500,
            total: 0,
            arrSelected: [],
            selectAll: false,
            listPartner: [],
            listProductionProcess: [],
            listMaterial: [],
            listProductionMethods: [],
            list_catalog: []
        }
    }

    componentDidMount() {
        this._fetchListSku()
        this._getPartner()
        this._getMaterial()
        this._getProductionMethod()
        this._getProductionProcess()
        this._getListCatalog()
    }

    _getListCatalog = async () => {
        try {
            const { success, data, message: mess } = await getListCatalog({ page: 1, limit: 10000 })
            if (!success) {
                throw new Error(mess)
            }
            this.setState({
                list_catalog: data.data || []
            })
        } catch (error) {
            console.log(error.message)
        }
    }
    _getPartner = async () => {
        const payload = {
            page: 1,
            limit: 10000,
            hidden: false,
        }
        try {
            const { data, success } = await getListPartner(payload)
            const { partners: listPartner } = data
            if (!success) return

            this.setState({
                listPartner
            })
        } catch (e) {
        }
    }

    _getProductionProcess = async () => {
        const payload = {
            page: 1,
            limit: 10000,
        }
        try {
            const { data: res } = await getProductionProcess(payload)
            const { data, success } = { ...res }
            const { result } = { ...data }
            if (!success) return

            this.setState({
                listProductionProcess: result
            })
        } catch (e) {
        }
    }

    _getMaterial = async () => {
        const payload = {
            page: 1,
            limit: 10000,
        }
        try {
            const { data: res } = await getListMaterials(payload)
            const { data, success } = res
            if (!success) return

            this.setState({
                listMaterial: data.data || []
            })
        } catch (e) {
        }
    }

    _getProductionMethod = async () => {
        const payload = {
            page: 1,
            limit: 10000,
        }
        try {
            const { data: res } = await getListProductionMethods(payload)
            const { data, success} = res
            if (!success) return

            this.setState({
                listProductionMethods: data.data || []
            })
        } catch (e) {
        }
    }

    _fetchListSku = async () => {
        this.setState({
            loading: true,
            error: '',
            message: '',
            arrSelected: [],
            selectAll: false
        })

        try {
            const { limit, page, filters } = this.state
            const newFilters = Object.assign({}, filters)

            if (newFilters.is_active === '') {
                delete newFilters.is_active
            }

            const payload = {
                limit,
                page,
                sort: '-created_at',
                ...newFilters
            }

            const { 'data': responsive } = await getListSku(payload)

            const { success, data, message } = responsive

            if (!success) {
                return this.setState({
                    loading: false,
                    error: message
                })
            }

            this.setState({
                loading: false,
                products: data.items,
                total: data.total
            })
        } catch (err) {
            this.setState({
                loading: false,
                error: err.message
            })
        }
    }

    _handleChangeFilter = (name, value) => {
        const { filters } = this.state

        this.setState({
            filters: {
                ...filters,
                [name]: value === 'false' ? false : value
            },
            page: 1
        }, () => {
            this._fetchListSku()
        })
    }

    _handleChangeFilters = (name, value) => {
        const { filters } = this.state

        this.setState({
            filters: {
                ...filters,
                [name]: value
            },
            page: 1
        })
    }

    _handleChangeFilterName = (name, value) => {
        const { filters } = this.state

        this.setState({
            filters: {
                ...filters,
                [name]: value === 'false' ? false : value
            },
            page: 1
        }, () => {
            if (this.timeout) clearTimeout(this.timeout)
            this.timeout = setTimeout(() => {
                this._fetchListSku()
            }, 1000)
        })
    }

    _handleChangePage = (page) => {
        this.setState({
            page: page
        }, () => {
            this._fetchListSku()
        })
    }

    _handleChangeLimit = (limit) => {
        this.setState({
            limit: limit,
            page: 1
        }, () => {
            this._fetchListSku()
        })
    }

    _updateSelectedSku = (id, isAdded) => {
        this.setState(({ arrSelected }) => {
            if (isAdded && !arrSelected.includes(id)) {
                return {
                    arrSelected: [...arrSelected, id],
                    selectAll: arrSelected.length + 1 === this.state.products.length,
                }
            } else {
                const filtered = arrSelected.filter(item => item !== id)

                return {
                    arrSelected: filtered,
                    selectAll: false,
                }
            }
        })
    }

    _handleCheckALl = (isChecked) => {
        this.setState(() => {
            if (isChecked) {
                const { products } = this.state
                const skuID = products.map(item => item._id)

                return {
                    arrSelected: skuID,
                    selectAll: true,
                }
            }

            return {
                arrSelected: [],
                selectAll: false,
            }
        })
    }

    render() {
        const { filters, limit, total, page, products, loading, error, selectAll, arrSelected, listPartner, listMaterial, listProductionMethods, listProductionProcess, list_catalog } = this.state
        const token = getLocalData('accessToken')
        const user = token !== '' && parseJwt(token).permissions ? parseJwt(token).permissions : {}
        const isFFMView = user.hasOwnProperty('base_cost_management')

        return (
            <div className="SkuPage">
                <Card>
                    <div className="CardHeader card-header header-elements-inline">
                        <h1 className='card-title'>Quản lý Sku</h1>
                        <div className="header-elements">
                            <Link to="/categories">Danh mục sản phẩm</Link>
                            <Link to="/materials" className="ml-3">Nguyên vật liệu</Link>
                            <Link to="/production-methods" className="ml-3">Phương pháp sản xuất</Link>
                            {isFFMView && <Import fetchListSku={this._fetchListSku} />}
                            <AddNew
                                listPartner={listPartner}
                                listMaterial={listMaterial}
                                listProductionMethods={listProductionMethods}
                                listProductionProcess={listProductionProcess}
                                list_catalog={list_catalog}
                            />
                        </div>
                    </div>

                    <CardBody>
                        <SkuFilters
                            filters={filters}
                            onChangeFilter={this._handleChangeFilter}
                            onChangeFilters={this._handleChangeFilters}
                            onChangeFilterName={this._handleChangeFilterName}
                            listPartner={listPartner}
                            listProductionProcess={listProductionProcess}
                            list_catalog={list_catalog}
                            listMaterial={listMaterial}
                        />
                        {
                            products.length > 0 && <SkuTotal
                                products={products}
                                selectAll={selectAll}
                                arrSelected={arrSelected}
                                limit={limit}
                                total={total}
                                onChangeLimit={this._handleChangeLimit}
                                onRefresh={this._fetchListSku}
                            />
                        }
                        <SkuTable
                            selectAll={selectAll}
                            arrSelected={arrSelected}
                            products={products}
                            loading={loading}
                            error={error}
                            onRefresh={this._fetchListSku}
                            onCheckALl={this._handleCheckALl}
                            onSelected={this._updateSelectedSku}
                        />
                        <div className="mt-3 float-right">
                            <NextPagination
                                limit={limit}
                                total={total}
                                page={page}
                                onChange={this._handleChangePage}
                            />
                        </div>
                    </CardBody>
                </Card>
            </div>
        )
    }
}

export default SkuPage